<template>
    <div>
        <h2>Elfelejtett jelszó</h2>
        <a-form 
            id="forgotten-password-form"
            :form="forgottenForm"
            class="forgottenForm"
            v-on:submit="formSubmit"
        >
            <a-form-item>
                <a-input
                    v-decorator="[
                        'userName',
                        {
                            rules: [{
                                required: true,
                                message: 'Kérjük írja be felhasználónevét'
                            }]
                        }
                    ]"
                    placeholder="Felhasználónév"
                >
                    <a-icon
                        slot="prefix"
                        type="user"
                        style="color: rgba(0, 0, 0, 0.5)"
                    >

                    </a-icon>
                </a-input>
            </a-form-item>
            <a-form-item>
                <a-input
                    v-decorator="[
                        'email',
                        {
                            rules: [{
                                required: true,
                                message: 'Kérjük írja be az e-mail címét'
                            }]
                        }
                    ]"
                    type="email"
                    placeholder="E-mail"
                >
                    <a-icon
                        slot="prefix"
                        type="mail"
                        style="color: rgba(0, 0, 0, 0.5)"
                    >

                    </a-icon>
                </a-input>
            </a-form-item>
            <a-divider
                
            ></a-divider>
            <a-form-item>
                <router-link class="to-login"  :to="{name: 'login'}">
                    <span>
                        Vissza a bejelentkezéshez
                    </span>
                </router-link>
                <a-button
                    :loading="forgottenLoading"
                    type="primary"
                    html-type="submit"
                    class="forgotten-form-button"
                >
                    Elküld
                </a-button>
                <div
                    
                >
                    <a-alert
                        v-if="forgottenError"
                        :message="forgottenError.message"
                        type="error"
                        :showIcon="true"
                        :closable="true"
                        :banner="true"
                        :afterClose="clearError"
                    />
                </div>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
// import { USER_LOGIN } from '@/action_types.js';
// import LocalStorage from '@/helpers/localstorage';
import axios from 'axios';


export default {
    
    beforeCreate() {
        this.forgottenForm = this.$form.createForm(this);
    },

    data() {
        return {
            forgottenLoading: false,
            forgottenError: null
        }
    },

    methods: {
        formSubmit(e) {
    
            e.preventDefault();
            this.forgottenForm.validateFieldsAndScroll((err, vals) => {
                console.log('ERR', err);
                console.log('VALS', vals);
                if (!err) {
                    this.$router.push({
                        name: 'app'
                    })
                    // this.forgottenLoading = true;

                    // axios.post('/api/login', {
                    //     username: vals.userName,
                    //     password: vals.password
                    // })
                    // .then((res) => {
                    //     const data = res.data.data;

                    //     this.$store.dispatch({
                    //         type: USER_LOGIN,
                    //     })
                    //     this.forgottenLoading = false;
                    // })
                    // .catch((err) => {
                    //     const errorResponse = err.response.data.errors[0];

                    //     let status = errorResponse.status
                    //     let message = errorResponse.title

                    //     if (status === 401) {
                    //         message = 'Hibás felhasználónév, vagy jelszó.'
                    //     }

                    //     this.forgottenError = {
                    //         message: `${status}: ${message}`
                    //     }
                    //     this.forgottenLoading = false;
                    // })
                }
            })

        },

        clearError() {
            this.forgottenError = null;
        }
    }
}
</script>

<style lang="scss" scoped>
    h2 {
        text-align: center;
    }
    .to-login {
        float: right;
    }
    .remember-button {
        float:left;
    }
    .forgotten-form-button {
        width: 100%
    }
</style>
